module.exports = __webpack_public_path__ + "img/wiperx_01.37669bb7.jpg";